import { motion } from "framer-motion";
import { useLang } from "@/i18n";
import { SectionHeading } from "@/components/Reveal";

export default function Process() {
  const { t } = useLang();
  return (
    <section id="method" className="py-24 lg:py-32 bg-obsidian relative overflow-hidden" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.4fr] gap-14 lg:gap-20">
          <div>
            <SectionHeading overline={t.process.overline} title={t.process.title} text={t.process.text} testid="process-title" />
          </div>
          <ol className="relative" data-testid="process-steps">
            <motion.div
              className="absolute left-[19px] top-2 bottom-2 w-px bg-gradient-to-b from-gold/60 via-gold/25 to-transparent origin-top"
              initial={{ scaleY: 0 }}
              whileInView={{ scaleY: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
            />
            {t.process.steps.map((s, i) => (
              <motion.li
                key={s.name}
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
                className="relative pl-16 pb-12 last:pb-0 group"
                data-testid={`process-step-${i}`}
              >
                <span className="absolute left-0 top-0 w-10 h-10 flex items-center justify-center border hairline rounded-full bg-obsidian font-mono text-[11px] text-gold group-hover:bg-gold group-hover:text-obsidian transition-colors duration-300">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="font-serif text-xl sm:text-2xl font-medium text-slate-100 tracking-wide uppercase">{s.name}</h3>
                <p className="mt-2 text-sm sm:text-base text-slate-400 font-light leading-relaxed max-w-md">{s.desc}</p>
              </motion.li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
